import { store } from 'redux/store';

import { Partner, Society } from 'types';

import { getDocument } from 'modules/documents/redux/documentActions';
import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';

type GenerateSharesOwnershipCertificateProps = {
  partner: Partner | null;
  society: Society;
};

type LanguageMap = {
  [key: string]: string | undefined;
};

const getDocumentName = (partner: Partner | null): string => {
  const partnerLanguage = partner?.language || 'es';

  const defaultName = `Certificado Titularidad Accionista ${partner?.name}.pdf`;

  const languageMap: LanguageMap = {
    es: defaultName,
    cat: `Certificat de Titularitat d'Accionista ${partner?.name}.pdf`,
  };

  return languageMap[partnerLanguage] || defaultName;
};

const getSharesOwnershipCertificateDocumentId = (
  society: Society,
  partner: Partner | null
) => {
  const partnerLanguage = partner?.language || 'es';

  const languageMap: LanguageMap = {
    es: society?.templates?.sharesOwnershipCertificateES,
    cat: society?.templates?.sharesOwnershipCertificateCA,
  };

  return languageMap[partnerLanguage];
};

const getSharesOwnershipCertificateFooterDocumentId = (society: Society) =>
  society?.templates?.sharesOwnershipCertificateFooter;

const getPartnerId = (partner: Partner | null) => partner?.['_id'];

const getDocumentIds = (society: Society, partner: Partner | null) => {
  const sharesOwnershipCertificateDocumentId =
    getSharesOwnershipCertificateDocumentId(society, partner);
  const sharesOwnershipCertificateFooterDocumentId =
    getSharesOwnershipCertificateFooterDocumentId(society);

  return {
    sharesOwnershipCertificateDocumentId,
    sharesOwnershipCertificateFooterDocumentId,
  };
};

export const generateSharesOwnershipCertificate = async ({
  partner,
  society,
}: GenerateSharesOwnershipCertificateProps) => {
  const documentName = getDocumentName(partner);

  const {
    sharesOwnershipCertificateDocumentId,
    sharesOwnershipCertificateFooterDocumentId,
  } = getDocumentIds(society, partner);

  const sharesOwnershipCertificateFooterDocument =
    sharesOwnershipCertificateFooterDocumentId
      ? await store.dispatch(
          getDocument(sharesOwnershipCertificateFooterDocumentId)
        )
      : null;
  const partnerId = getPartnerId(partner);

  const sources = {
    partner: partnerId,
    society: society?._id,
  };

  if (sharesOwnershipCertificateDocumentId && partnerId) {
    await generateDocumentWithTags({
      documentId: sharesOwnershipCertificateDocumentId,
      documentName,
      sources,
      language: partner?.language || 'es',
      footerHtml: sharesOwnershipCertificateFooterDocument?.editorModel || '',
      textPadding: { top: '20mm', right: '6mm', bottom: '20mm', left: '6mm' },
      showOnlyValues: false,
    });
  }
};
